import apiRequest from './api-request';

const resource = 'tenants';

export function getTenants() {
    return apiRequest({
        method: 'GET',
        resource
    });
}

export function getTenantsForMap() {
    return apiRequest({
        method: 'GET',
        resource: `${resource}/for-map`
    });
}

export function getTenant(id: number | string) {
    return apiRequest({
        method: 'GET',
        resource,
        id
    });
}

export function getTenantMeta(id: number | string) {
    return apiRequest({
        method: 'GET',
        resource: `${resource}/${id}/meta`
    });
}

export function createTenant(body: any) {
    return apiRequest({
        method: 'POST',
        resource,
        body
    });
}

export function acceptTenant(id: number | string, isAccepted: boolean) {
    return apiRequest({
        method: 'PUT',
        resource: `${resource}/${id}/accept`,
        body: { isAccepted }
    });
}

export function rejectTenant(id: number | string, isRejected: boolean) {
    return apiRequest({
        method: 'PUT',
        resource: `${resource}/${id}/reject`,
        body: { isRejected }
    });
}

export function updateTenant(id: number | string, body: any) {
    return apiRequest({
        method: 'PUT',
        resource,
        id,
        body
    });
}

export function deleteTenant(id: number | string) {
    return apiRequest({
        method: 'DELETE',
        resource,
        id
    });
}

export function searchTenants(query: string) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/search`,
        body: { query }
    });
}

export function getPresignedLogoUrl(tenantId: number | string, body: { mimeType: string }) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${tenantId}/logo/presign`,
        body
    });
}

export function confirmLogoUpload(tenantId: number | string, body: { mimeType: string }) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${tenantId}/logo/confirm`,
        body
    });
}

export type RecommendationDirection = 'received' | 'given';

export type TenantRecommendationParty = {
    id: number,
    name: string,
    orgNumber: string,
    slug: string | null,
    isVerified: boolean,
    createdAt: string
};

export type TenantRecommendationsResponse = {
    received: TenantRecommendationParty[],
    given: TenantRecommendationParty[]
};

export function getTenantRecommendations(tenantId: number | string) {
    return apiRequest({
        method: 'GET',
        resource: `${resource}/${tenantId}/recommendations`
    }) as Promise<TenantRecommendationsResponse>;
}

export function addTenantRecommendation(
    tenantId: number | string,
    body: { otherTenantId: number, direction: RecommendationDirection }
) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${tenantId}/recommendations`,
        body
    });
}

export function removeTenantRecommendation(
    tenantId: number | string,
    otherTenantId: number,
    direction: RecommendationDirection
) {
    return apiRequest({
        method: 'DELETE',
        resource: `${resource}/${tenantId}/recommendations/${direction}/${otherTenantId}`
    });
}
